import React from 'react';
import { CapaQuotationChatMessageRfq } from '@generated/graphql';
import { colorSet } from '@components/Provider';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import PurchaseOrderProgressPresenter from './PurchaseOrderProgressPresenter';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from '@store';
import { isClosedTypes } from '@components/Chat/types';
import useDocuments from '@hooks/useDocuments';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all'
    },
    footer: {
      padding: 16
    }
  };
});

interface Props {
  message?: CapaQuotationChatMessageRfq;
}

const PurchaseOrderAdjustRequestBubble: React.FC<Props> = ({ message }) => {
  const classes = useStyles();
  const history = useHistory();

  const { onUpdateDocumentsCurrentId } = useDocuments();

  const menuStatus = useSelector(
    (state) => state.chat.menuStatus?.purchaseOrder
  );

  const chatRoomStatus = useSelector((state) => state.chat.chatRoomStatus);

  const isClosed = chatRoomStatus
    ? isClosedTypes.includes(chatRoomStatus)
    : false;

  const content = message?.rfq?.adjustRequest ?? '';

  const onClick = () => {
    if (message?.rfq?.purchaseOrderId) {
      onUpdateDocumentsCurrentId({
        selectedPurchaseOrderId: message?.rfq?.purchaseOrderId ?? undefined
      });
    }

    history.push(history.location.pathname + '?menu=purchaseorder');
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          발주서
        </CustomizedTypography>
      </div>
      <PurchaseOrderProgressPresenter activeStep={1} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            발주서 수정 요청 도착
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            파트너로 부터 아래와 같은 내용의 발주서 수정 요청이 도착했습니다.
            <br />
            <br />
            {content}
          </CustomizedTypography>
        </div>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          disabled={menuStatus || isClosed}
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          onClick={onClick}
        >
          발주서 수정하기
        </CustomizedButton>
      </div>
    </div>
  );
};

export default PurchaseOrderAdjustRequestBubble;
